/* eslint-disable */
import type { Money } from "../../../../common/currency.pb";
import type { BitcoinAmount } from "../../../crypto/amount.pb";

/** A crypto-sparky view of a lightning deposit. */
export interface LightningDeposit {
  /** The lightning deposit's unique token */
  token?: string;
  /** The time in epoch millis that this deposit was created */
  created_at?: number;
  /** The time in epoch millis that this deposit was updated */
  updated_at?: number;
  /** The time in epoch millis when this deposit was received */
  paid_at?: number;
  /** Each time the deposit's state is updated, the version increments. Zero-based. */
  version?: number;
  /** The amount being deposited. */
  amount?: BitcoinAmount;
  /** The state of this deposit, in terms of the crypto-sparky state machine */
  state?: string;
  /** The usd equivalent at time of creation */
  usd_equivalent?: Money;
  /** The fiat equivalent in the customer's local currency */
  fiat_equivalent?: Money;
  /** The source stored balance token from where the funds are deposited */
  source_balance_token?: string;
  /** The transaction token generated by Banklin */
  transaction_token?: string;
  /** The payment hash from the lightning invoice */
  payment_hash?: string;
  /** The customer token */
  customer_token?: string;
  /** The reason attributed to the failure of this deposit, if applicable */
  failure_reason?: string;
  /** The lightning network invoice the customer has generated */
  invoice?: string;
  /** The time in epoch milliseconds when this invoice will expire */
  expire_timestamp?: number;
  /** The duration that the invoice is valid for */
  expire_duration?: number;
  /** The amount on the original invoice */
  invoice_amount?: LightningDepositInvoiceAmount;
  /** An optional note on the lightning invoice */
  description?: string;
}

export enum LightningDepositEventType {
  /** EVENT_TYPE_UNKNOWN - Default is undefined and indicates a versioning error. */
  EVENT_TYPE_UNKNOWN = "EVENT_TYPE_UNKNOWN",
  /**
   * DEPOSIT_GENERATED - The deposit has been generated.
   * This event does not represent a transition, it is only emitted on creation.
   */
  DEPOSIT_GENERATED = "DEPOSIT_GENERATED",
  /**
   * DEPOSIT_NOTIFIED - The customer has been notified of a generated deposit.
   * Represents a transition from GENERATED to PENDING.
   */
  DEPOSIT_NOTIFIED = "DEPOSIT_NOTIFIED",
  /**
   * DEPOSIT_VALID - The deposit has been validated and is ready to be paid.
   * Represents a transition from PENDING to VALID.
   */
  DEPOSIT_VALID = "DEPOSIT_VALID",
  /**
   * DEPOSIT_INVALID - The deposit has failed validation.
   * Represents a transition from PENDING to INVALID.
   */
  DEPOSIT_INVALID = "DEPOSIT_INVALID",
  /**
   * DEPOSIT_REJECTED - The payment attempt has failed and the deposit has been rejected.
   * Represents a transition from VALID/INVALID to REJECTED
   */
  DEPOSIT_REJECTED = "DEPOSIT_REJECTED",
  /**
   * DEPOSIT_SETTLED - The funds have been credited to the customer.
   * Represents a transition from VALID to RECEIVED.
   */
  DEPOSIT_SETTLED = "DEPOSIT_SETTLED",
}

export interface LightningDepositInvoiceAmount {
  /** The optional amount on the generated invoice */
  amount?: BitcoinAmount;
  /** The usd equivalent at time of creation */
  usd_equivalent?: Money;
  /** The fiat equivalent in the customer's local currency */
  fiat_equivalent?: Money;
}

export interface LightningDepositInvoiceGeneration {
  payment_request?: string;
  unified_address?: string;
  deposit_address?: string;
  /** The fiat equivalent in the customer's local currency */
  fiat_equivalent?: Money;
  qr_code_url?: string;
  share_url?: string;
}
